import { AppNS } from 'app';
import camelCaseKeys from 'camelcase-keys';

export const parseThread = (item: AppNS.Params): AppNS.MessageThread => {
  return {
    ...item,
    participants: [parseParticipant(item.participant[0], item?.booking)],
    messages: [] as Array<AppNS.Message>,
  } as AppNS.MessageThread;
};

export const parseMessage = (item: AppNS.Params): AppNS.Message => {
  return {
    ...item,
    actions: item.actions ? camelCaseKeys(item.actions) : [],
  } as AppNS.Message;
};

export const parseParticipant = (
  item: AppNS.ThreadParticipant | null,
  booking: AppNS.Params | undefined,
): AppNS.ThreadParticipant | null => {
  if (!item) {
    return null;
  }

  return {
    firstName: item.firstName,
    lastName: item.lastName,
    companyName: item.roles.includes('client') ? booking?.clientCompany?.name : booking?.agencyCompany?.name,
    fullName: item.fullName,
    id: item.id,
    avatar: item.avatar,
    roles: item.roles,
  };
};
